import { Middleware } from 'redux';
import toast from 'react-hot-toast';
import { setEditedFromSummary } from '../actions/application';
import { PAGES } from '../constants';
import SuccessIconGreen from '../icons/success_icon_green.svg';
import { SummaryToastContainer, SummaryToastText } from '../Components/Summary/SummaryToastStyles';

const showSummaryToast = () => {
  toast.dismissAll();
  toast.custom(
    (t) => (
      <SummaryToastContainer visible={t.visible} onClick={() => toast.dismiss(t.id)}>
        <img src={SuccessIconGreen} alt="" width={16} height={16} />
        <SummaryToastText>Quote Saved!</SummaryToastText>
      </SummaryToastContainer>
    ),
    { duration: 5000, position: 'top-center' }
  );
};

const summaryToast: Middleware<{}, ReduxState> = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === PAGES.SUMMARY) {
    const { editedFromSummary } = store.getState();
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile && editedFromSummary) {
      store.dispatch(setEditedFromSummary(false));
      showSummaryToast();
    }
  }

  return result;
};

export default summaryToast;
